import { render, staticRenderFns } from "./widgetLayoutTest.vue?vue&type=template&id=01231b8c&scoped=true"
import script from "./widgetLayoutTest.vue?vue&type=script&lang=js"
export * from "./widgetLayoutTest.vue?vue&type=script&lang=js"
import style0 from "./widgetLayoutTest.vue?vue&type=style&index=0&id=01231b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01231b8c",
  null
  
)

export default component.exports